export const APP_PATHS = {
    root: '',
    awsOffer: 'aws-offer',
    ssoLanding: 'sso-landing',
    directLink: 'l/:linkFormatVersion/:encodedFileData/:encodedEncryptedFileName',
    inviteLanding: 'i',
    activateAccount: 'activate-account',
    invite: 'invite',
    accountRecovery: 'account-recovery',
    backupCodeLogin: 'backup-code-login',
    passwordReset: 'password-reset',
    login: 'login',
    register: 'register',
    verifyEmail: 'verify-email',
    account: 'account',
    zendeskAuth: 'zendesk-auth',
};
export const WORKSPACE_PATHS = {
    workspaces: 'workspaces',
    workspacesCreate: 'workspaces/create',
    workspacesNoWorkspaces: 'workspaces/no-workspaces',
    workspaceOnboarding: 'workspace-onboarding',
    filespaceMigrate: 'filespace-migrate',
    workspace: 'workspaces/:workspaceId',
    workspaceLock: 'workspaces/:workspaceId/locked',
    workspaceSuspended: 'workspaces/:workspaceId/suspended',
    workspaceFilespaceCreate: 'workspaces/:workspaceId/filespace-create',
    workspaceSettings: 'workspaces/:workspaceId/settings',
    workspaceSettingsGeneral: 'workspaces/:workspaceId/settings/general',
    workspaceSettingsMembers: 'workspaces/:workspaceId/settings/members',
    workspaceSettingsMember: 'workspaces/:workspaceId/settings/members/:memberId',
    workspaceSettingsGroups: 'workspaces/:workspaceId/settings/groups',
    workspaceSettingsGroup: 'workspaces/:workspaceId/settings/groups/:groupId',
    workspaceSettingsPermissions: 'workspaces/:workspaceId/settings/permissions',
    workspaceSettingsTwoFactorAuthentication: 'workspaces/:workspaceId/settings/two-factor-authentication',
    workspaceSettingsSso: 'workspaces/:workspaceId/settings/sso',
    workspaceSettingsDomainManagement: 'workspaces/:workspaceId/settings/domain-management',
    workspaceSettingsDeveloperTools: 'workspaces/:workspaceId/settings/developer-tools',
    workspaceSettingsServiceAccounts: 'workspaces/:workspaceId/settings/service-accounts',
    workspaceSettingsServiceAccount: 'workspaces/:workspaceId/settings/service-accounts/:accountId',
    workspaceSettingsBillingPlans: 'workspaces/:workspaceId/settings/billing/plans',
};
export const FILESPACE_PATHS = {
    filespace: 'workspaces/:workspaceId/filespaces/:filespaceId',
    filespaceBrowser: 'workspaces/:workspaceId/filespaces/:filespaceId/browser',
    filespaceDashboard: 'workspaces/:workspaceId/filespaces/:filespaceId/dashboard',
    filespaceSnapshots: 'workspaces/:workspaceId/filespaces/:filespaceId/snapshots',
    filespaceSettings: 'workspaces/:workspaceId/filespaces/:filespaceId/settings',
    filespacePermissions: 'workspaces/:workspaceId/filespaces/:filespaceId/permissions',
    filespacePermissionsFsEntry: 'workspaces/:workspaceId/filespaces/:filespaceId/permissions/fs-entry/:fsEntryId',
    filespacePermissionsFsEntryCreate: 'workspaces/:workspaceId/filespaces/:filespaceId/permissions/fs-entry/create',
    filespacePermissionsPrincipal: 'workspaces/:workspaceId/filespaces/:filespaceId/permissions/principal/:principalId',
    filespacePermissionsPrincipalCreate: 'workspaces/:workspaceId/filespaces/:filespaceId/permissions/principal/:principalId/create',
    filespaceGuestLinks: 'workspaces/:workspaceId/filespaces/:filespaceId/guest-links',
    filespaceLucidLinkConnect: 'workspaces/:workspaceId/filespaces/:filespaceId/lucidlink-connect',
    filespaceLucidLinkConnectDataStore: 'workspaces/:workspaceId/filespaces/:filespaceId/lucidlink-connect/data-stores/:dataStoreRef',
};
